import { render, staticRenderFns } from "./pageSix.vue?vue&type=template&id=7bce7072&scoped=true&"
import script from "./pageSix.vue?vue&type=script&lang=js&"
export * from "./pageSix.vue?vue&type=script&lang=js&"
import style0 from "./pageSix.vue?vue&type=style&index=0&id=7bce7072&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bce7072",
  null
  
)

export default component.exports